<template>
    <div>
        <form-response-errors ref="formResponseErrors" :reload="reload"></form-response-errors>

        <div class="row" v-if="user.id">

            <div class="col-lg-6 col-xl-4">

                <div class="card card-primary card-outline" :class="{'card-danger': user.deleted_at }">
                    <div class="card-body box-profile">
                        <div class="text-center">
                            <i v-if="user.deleted_at" class="fas fa-trash-alt fa-2x text-danger"></i>
                            <i v-else class="fas fa-user fa-2x"></i>
                        </div>

                        <h3 class="profile-username text-center">{{ fio(user) }}</h3>


                        <p class="text-muted text-center" v-if="user.company">
                            <CompanyLink :company="user.company" :ico="true"></CompanyLink>
                        </p>

                        <p v-for="role in user.roles" class="text-muted text-center mb-0">
                            <i class="fas fa-user-tag mr-2"></i> {{ role.name }}
                        </p>

                        <ul class="list-group list-group-unbordered mt-3 mb-3">
                            <li class="list-group-item">
                                <b>{{ trans("user.email") }}</b>
                                <a class="float-right" :href="'mailto:' + user.email">{{ user.email }}</a>
                            </li>
                            <li class="list-group-item">
                                <b>{{ trans("user.Number of bets") }}</b>
                                <span class="float-right">{{ user.bets_cnt }}</span>
                            </li>
                            <li class="list-group-item">
                                <b>{{ trans("user.Number of Tenders Won") }}</b>
                                <span class="float-right">{{ user.tender_win_cnt }}</span>
                            </li>
                            <li class="list-group-item">
                                <b>{{ trans("user.Registration date") }}</b>
                                <span class="float-right">{{ momentFullDateTime(user.created_at) }}</span>
                            </li>
                            <li class="list-group-item">
                                <b>{{ trans("user.Last login date") }}</b>
                                <span class="float-right">{{ momentFullDateTime(user.last_login) }}</span>
                            </li>
                        </ul>


                        <router-link v-if="can('update-user', user)" :to="{name: 'user-edit', params: {id: user.id}}"
                                     class="btn btn-sm btn-primary mr-1">
                            <i class="fas fa-pencil-alt"></i>
                        </router-link>

                        <template v-if="can('create-user')">
                            <router-link :to="{ name: 'user-clone', params: { id: user.id } }"
                                         class="btn btn-sm btn-primary mr-1">
                                <i class="fas fa-clone"></i>
                            </router-link>
                        </template>

                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xl-8">

                <UserSettings :id="user.id"></UserSettings>

            </div>
        </div>
    </div>
</template>

<script>
import User from "../../models/User";
import UserService from "../../services/UserService";

export default {
    props: ['id'],
    data() {
        return {
            user: {}
        }
    },
    methods: {
        reload() {
            this.getData();
        },
        fio(user) {
            return User.fio(user);
        },
        async getData() {
            try {
                this.$refs.formResponseErrors.hide();
                let response = await UserService.getDetail(this.id, this.can('deleted-user-read'));
                this.user = response.data.data;
                this.$store.dispatch("breadcrumbs/setTitle", User.fio(this.user));
            } catch (error) {
                this.$refs.formResponseErrors.show(error);
            }
        }
    },
    mounted() {
        this.getData();
    },
}

</script>
